import * as React from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import { FormFieldComponentProps } from '../../../lib/types/types';
import { setRef } from '../../../lib/refs/refs';

interface PassedProps {
    explanation?: string | JSX.Element;
    onKeyDown?: Function;
}

const PhoneNumberComponent = ({
                            value,
                            isErrored,
                            onChange,
                            explanation,
                            onKeyDown = undefined,
                            placeholder = '',
                        }: FormFieldComponentProps & PassedProps) => {
    return (
        <div className="sid-field sid-phone-number">
            <div className="sid-l-space-top-md" />
            <label htmlFor="sid-phone-number">
                <div className={`sid-field__label-with-explanation sid-l-space-btm-sm ${placeholder ? 'sid-h-screen-reader-only' : ''}`}>
                    <div className="sid-field__label">
                        <FormattedHTMLMessage
                            id="phoneNumber"
                            defaultMessage="Mobile Number"
                        />
                    </div>
                    <div className="sid-field__label-explanation">
                        {
                            explanation ? explanation :
                                <FormattedHTMLMessage
                                    id="phoneNumberExplanation"
                                    defaultMessage="Optional - get text notifications of status updates"
                                />
                        }
                    </div>
                </div>
            </label>
            <input
                className={
                    `sid-text-input 
                            sid-l-full-width ${isErrored ? 'sid-text-input--error' : ''}`
                }
                id="sid-phone-number"
                name="sid-phone-number"
                type="tel"
                value={value}
                onChange={e => onChange(e.target.value)}
                onKeyDown={e => onKeyDown ? onKeyDown(e) : undefined}
                placeholder={placeholder}
                ref={input => setRef('phoneNumber', input)}
            />

            {
                isErrored ? (
                    <div className="sid-field-error">
                        <FormattedHTMLMessage
                            id="errorId.invalidPhoneNumber"
                            defaultMessage="Invalid mobile number"
                        />
                    </div>
                ) : null
            }

            <div className="sid-h-small-text sid-l-space-top-md">
                By submitting this form with a mobile number, you consent to receive SMS/text messages for verification purposes. Standard phone carrier text messaging (SMS) and data rates may apply
            </div>
        </div>
    );
};

export {  PhoneNumberComponent };
